import { StatementTableColumnId } from './StatementTableColumns';
import { TableTotalsSummaryService } from '../Totals/TableTotalSummaryService';
export class StatementTableTotalService {
    constructor(storage) {
        this._storage = storage;
    }
    calculate(column, rows) {
        if (column.id === StatementTableColumnId.Amount || column.id === StatementTableColumnId.Quantity) {
            return this.calculateSum(column.id, rows);
        }
        return TableTotalsSummaryService.calculate(column, rows);
    }
    format(column, rows, value) {
        if (isNaN(value)) {
            return '';
        }
        if (column.id === StatementTableColumnId.Amount) {
            return value.toFixed(2);
        }
        if (column.id === StatementTableColumnId.Quantity) {
            return Number(value.toFixed(2)).toString();
        }
        return TableTotalsSummaryService.format(column, rows, value);
    }
    calculateSum(columnId, rows) {
        let total = 0;
        for (const row of rows) {
            const statement = this._storage.getStatement(row);
            if (statement === null)
                continue;
            const rawValue = columnId === StatementTableColumnId.Amount
                ? statement.getAmount()
                : statement.getQuantity();
            total += this.parseToValidNumber(rawValue);
        }
        return total;
    }
    parseToValidNumber(value) {
        const num = typeof value === 'string' ? parseFloat(value) : value;
        return typeof num === 'number' && !isNaN(num) ? num : 0;
    }
}
